import { AppState } from '../../../store/state/app.state';
import { BusinessCardComponent } from '../business-card/business-card.component';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Manager } from '../../../interfaces/manager.interface';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { ActionTypes } from '../../../store/actions/my-account.action';

@Component({
    selector: 'u4-cpp-account-manager',
    templateUrl: '../business-card/business-card.component.html',
    styles: []
})

export class AccountManagerComponent extends BusinessCardComponent implements OnInit {
    id = 'account-manager';
    labels: {[key: string]: string};
    manager$: Observable<Manager>;
    noManager$: Observable<any>;

    constructor(protected store: Store<AppState>) {
        super(store);
    }

    ngOnInit() {
        this.header = this.labels['usermanagement.your-account-manager'];

        this.manager$ = this.store.select(state => state.account).pipe(
            map(res => res.accountManager),
            takeUntil(this.destroy$)
        );
        this.store.dispatch({type: ActionTypes.LoadAccount});
    }

}
